import { msg } from '@lingui/core/macro';
import { translateLazy } from '@utils/translations.ts';

export const TOOLBAR_OPTIONS = {
    FULLSCREEN: 'fullscreen',
    PRINT: 'print',
    DOWNLOAD: 'download',
    ZOOM_IN: 'zoomIn',
    ZOOM_OUT: 'zoomOut',
    PREV: 'prevPage',
    NEXT: 'nextPage',
    PAGE_COUNT: 'pageCount',
    ROTATE_CLOCKWISE: 'rotateClockwise',
    ROTATE_COUNTERCLOCKWISE: 'rotateCounterClockwise',
    SCALE_SELECT: 'scaleSelect',
    FIND: 'find',
    CURSOR_TOOLS: 'cursorTools',
    SCROLL_MODES: 'scrollModes',
    TOGGLE_SIDEBAR: 'toggleSidebar',
    BOOKMARK: 'viewBookmark',
    FIRST_PAGE: 'firstPage',
    LAST_PAGE: 'lastPage',
    EXTRA_TOOLS: 'extraTools',
};

export type ToolbarOption = (typeof TOOLBAR_OPTIONS)[keyof typeof TOOLBAR_OPTIONS];

export const DEFAULT_TOOLBAR: ToolbarOption[] = [
    TOOLBAR_OPTIONS.FULLSCREEN,
    TOOLBAR_OPTIONS.PRINT,
    TOOLBAR_OPTIONS.DOWNLOAD,
    TOOLBAR_OPTIONS.ZOOM_IN,
    TOOLBAR_OPTIONS.ZOOM_OUT,
    TOOLBAR_OPTIONS.PREV,
    TOOLBAR_OPTIONS.NEXT,
    TOOLBAR_OPTIONS.PAGE_COUNT,
    TOOLBAR_OPTIONS.ROTATE_CLOCKWISE,
    TOOLBAR_OPTIONS.ROTATE_COUNTERCLOCKWISE,
    TOOLBAR_OPTIONS.SCALE_SELECT,
    TOOLBAR_OPTIONS.FIND,
    TOOLBAR_OPTIONS.CURSOR_TOOLS,
    TOOLBAR_OPTIONS.SCROLL_MODES,
    TOOLBAR_OPTIONS.TOGGLE_SIDEBAR,
    TOOLBAR_OPTIONS.BOOKMARK,
    TOOLBAR_OPTIONS.FIRST_PAGE,
    TOOLBAR_OPTIONS.LAST_PAGE,
    TOOLBAR_OPTIONS.EXTRA_TOOLS,
];

export const SCALE_OPTIONS_VALUES = {
    AUTO: 'auto',
    PAGE_ACTUAL: 'page-actual',
    PAGE_FIT: 'page-fit',
    PAGE_WIDTH: 'page-width',
};

export const scaleOptions = [
    { value: SCALE_OPTIONS_VALUES.AUTO, label: translateLazy(msg`Auto`) },
    { value: SCALE_OPTIONS_VALUES.PAGE_ACTUAL, label: translateLazy(msg`Actual Size`) },
    { value: SCALE_OPTIONS_VALUES.PAGE_FIT, label: translateLazy(msg`Page Fit`) },
    { value: SCALE_OPTIONS_VALUES.PAGE_WIDTH, label: translateLazy(msg`Page Width`) },
    { value: '0.5', label: '50%' },
    { value: '0.75', label: '75%' },
    { value: '1', label: '100%' },
    { value: '1.25', label: '125%' },
    { value: '1.5', label: '150%' },
    { value: '2', label: '200%' },
    { value: '3', label: '300%' },
    { value: '4', label: '400%' },
];

// Allow a small scroll tolerance because browsers can report fractional scroll values after zoom,
// fit-width scaling, and canvas rendering.
export const SCROLL_BOTTOM_TOLERANCE_PX = 2;

// Extra delayed height recalculations keep rc-virtual-list aligned after hard refresh,
// when PDF loading, fit-width scaling, and canvas rendering can settle at different times.
export const PDF_HEIGHT_RECALCULATION_DELAYS_MS = [100, 300];

// Short PDFs can fit into the viewer without creating a scrollbar.
// For those files, we only complete when the last page is almost fully visible.
export const SHORT_PDF_MAX_PAGES = 2;
export const SHORT_PDF_FULL_VISIBILITY_RATIO = 0.98;
